<template>
    <div class="md-feature-area-crumb standard" v-if="featureArea && featureArea.state">
        <div class="crumb-container">
            <module-box
                class="crumb"
                :mobileBtmSpacing="14"
                :btmSpacing="26"
                :topSpacing="15"
                :mobileTopSpacing="15"
                :containerStyle="{ paddingBottom: '15px' }"
                :class="{ mobile: platform.isMobile }"
            >
                <div class="crumb-area">
                    <span class="area state"
                    >{{ featureArea.state
                    }}<i class="iconfont icon-arrow_01_right"></i
                    ></span>
                    <template v-if="featureArea.city">
                        <a
                            :href="cityLink"
                            rel="noopener norefferrer"
                            class="area city"
                            :class="{ disabled: featureArea.type === 'city' }"
                        >{{ featureArea.city
                        }}<i
                            v-if="featureArea.neighborhood"
                            class="iconfont icon-arrow_01_right"
                        ></i
                        ></a>
                        <template v-if="featureArea.neighborhood">
                            <span class="area neighborhood disabled">{{
                                featureArea.neighborhood
                            }}</span>
                        </template>
                    </template>
                </div>
                <div class="area-overview" v-if="areaIntroLink">
                    <a :href="areaIntroLink" rel="noopener norefferrer" >{{ $t('md-featured-area-crumb:areaOverview') }}<i class="iconfont icon-arrow"></i></a>
                </div>
            </module-box>
        </div>

        <module-box class="intro" :class="{ mobile: platform.isMobile }">
            <div class="intro-top">
                <h2 class="name" v-if="featureArea.name">
                    {{ featureArea.name }}
                </h2>
                <a
                    class="market-insights"
                    rel="noopener norefferrer"
                    v-if="!platform.isMobile"
                    :href="rightLink.link"
                >
                    <i :class="'iconfont ' + rightLink.icon"></i
                    >{{ rightLink.text }}
                </a>
            </div>
            <p class="feature-description">
                {{ description }}
            </p>
            <div class="market-insights" v-if="platform.isMobile">
                <a
                    rel="noopener norefferrer"
                    class="market-link"
                    :href="rightLink.link"
                >
                    <i :class="'iconfont ' + rightLink.icon"></i
                    >{{ rightLink.text }}
                </a>
            </div>
        </module-box>
    </div>
</template>
<script>
import common from '../index.js';
export default common;
</script>
<style lang="scss">
.md-feature-area-crumb.standard {
    .crumb-container {
        background: rgba(0, 0, 0, 0.03);
        .mg-container.crumb {
            height: 48px;
            display: flex;
            justify-content: space-between;
            &.mobile {
                display: block;
                height: auto;
                .area-overview {
                    font-size: 12px;
                    margin-top: 10px;
                    .iconfont {
                        font-size: 14px;
                    }
                }
            }
            .area {
                font-size: 14px;
                color: #000;
                font-family: var(--font-normal);
                line-height: 17px;
                &.disabled {
                    color: #a8a8a8;
                    cursor: not-allowed;
                }
                .iconfont.icon-arrow_01_right {
                    font-size: 12px;
                    margin: 0 8px;
                    color: #a8a8a8;
                }
            }
            .area-overview {
                font-size: 14px;
                font-family: var(--font-normal);
                line-height: 17px;
                color: #505050;
                margin-right: 8px;
                .iconfont {
                    font-size: 16px;
                    color: #a8a8a8;
                    margin-left: 8px;
                }
                &:hover {
                    color: var(--color-theme);
                    text-decoration: underline;
                    .iconfont{
                        color: var(--color-theme);
                    }
                }
            }
        }
        .area-overview {
            width: fit-content;
        }
    }
    .intro {
        &.mobile {
            .feature-description {
                margin-top: 15px;
                border-bottom: 0;
                padding-bottom: 0px;
            }
            .market-insights {
                padding-bottom: 20px;
                border-bottom: 1px solid #e1e2e6;
                margin-top: 10px;
                border-radius: 5px;
                display: block;
                border: 1px solid #dadada;
                text-align: center;
                padding: 12px 0;
                line-height: 1;
                .market-link {
                    color: var(--color-text);
                    font-size: 14px;
                    .iconfont {
                        margin-right: 10px;
                        color: #a8a8a8;
                        transform: translateY(2px);
                        display: inline-block;
                    }
                }
            }
            .intro-top {
                .name {
                    font-size: 16px;
                }
            }
        }
        .intro-top {
            display: flex;
            justify-content: space-between;
            .name {
                color: #191919;
                font-family: var(--mg-title-font);
                line-height: 1;
                font-size: 24px;
            }
            .market-insights {
                cursor: pointer;
                color: #505050;
                .iconfont {
                    margin-right: 10px;
                    display: inline-block;
                    transform: translateY(1px);
                    color: #a8a8a8;
                }
                &:hover {
                    color: var(--color-theme);
                    text-decoration: underline;
                    .iconfont {
                        color: var(--color-theme);
                    }
                }
            }
        }
        .feature-description {
            margin-top: 27px;
            padding-bottom: 40px;
            border-bottom: 1px solid #e1e2e6;
            color: #191919;
            font-size: 14px;
            line-height: 21px;
            font-family: var(--font-medium);
        }
    }
}
</style>
